import styled from 'styled-components';
import Imgix from 'shared/components/imgix';

export const Container = styled.div<{ isActive?: boolean }>`
  align-items: center;
  border-radius: 8px;
  justify-content: space-between;
  box-shadow: 0 3px 5px #e9ecf1;
  display: flex;
  padding: 16px;
  background: #ffffff;
  margin-bottom: 16px;
  border: 1px solid #d3d8de;

  ${({ isActive }) => !isActive && `background: #f3f6f8; `}
`;

export const ImageContainer = styled.div`
  border: 1px solid #e1e6eb;
  border-radius: 8px;
  margin-right: 17px;
  overflow: hidden;
`;

export const Image = styled(Imgix)<{ src: string; htmlAttributes: any; imgixParams: any; disableSrcSet?: boolean }>`
  display: block;
`;

export const LinkContainer = styled.div`
  align-items: center;
  color: #a0a6ac;
  display: flex;
  flex-grow: 1;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.65;

  a {
    color: #0b99e6;
  }
`;

export const LinkWrapper = styled.div`
  font-weight: 600;
`;

export const PlatformLinks = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const PlatformLinkContainer = styled(LinkContainer)`
  border-right: 1px solid #d9d9d9;
  flex-grow: 0;
  font-weight: normal;
  line-height: 1;
  margin-right: 20px;
  padding-right: 20px;

  &:last-child {
    border-right: none;
    padding-right: 0;
    margin-right: 0;
  }

  p {
    margin-right: 8px;
  }

  a {
    align-items: center;
    display: flex;
  }

  a,
  b {
    font-weight: 700;
  }

  b,
  svg {
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
  }

  svg {
    margin-right: 3px;
  }
`;

export const DragHandleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Controls = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 62px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 10px;
    cursor: pointer;
    transition: 0.15s opacity;
    fill: #6d747b;

    &:hover {
      fill: #0b99e6;
    }
  }
`;

export const LinksAndSchedule = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 12px;
`;
